import ip from 'ip';
import { OPERATIONS_MAP, OPERATIONS, STATUSES } from '@/common/constants/reconfiguration.constants';

export default {
  CHECK_RECONFIGURATION({ dispatch, state }) {
    dispatch('CLEAR_OPERATION_STATE');
    return this.$takeFirst('reconfiguration/GET_RUNNING_TASK')
      .then((res) => (state.operation && state.taskId)
        ? this.$takeFirst('reconfiguration/GET_OPERATION_STATE')
        : res
      )
      .catch((err) => {
        dispatch('CLEAR_OPERATION_STATE');
        throw err;
      });
  },
  GET_RUNNING_TASK({ commit }) {
    return this.$api.get('/api/v2/network/reconfiguration/')
      .then((res) => {
        const runningOperation = OPERATIONS_MAP[res.data.link?.rel] || res.data.link?.rel;
        commit('SET_TASK', res.data.task_id);
        commit('SET_OPERATION', runningOperation);
        return res;
      });
  },

  GET_OPERATION_STATE({ commit, state }, payload = {}) {
    const { operation = state.operation, taskId = state.taskId } = payload;
    if (!operation || !taskId) {
      return Promise.reject();
    }

    return this.$api.get(`/api/v2/network/${operation}/${taskId}/`)
      .then((res) => {
        commit('SET_TASK_STATE', res.data.state);
        commit('SET_TASK_PROGRESS', res.data.progress);
        commit('SET_OPERATION_DETAILS', res.data.configuration);
        return res;
      });
  },

  RUN_OPERATION({ commit }, { operation, body }) {
    return this.$api.post(`/api/v2/network/${operation}/`, body)
      .then((res) => {
        const runningOperation = OPERATIONS_MAP[res.data.link?.rel] || res.data.link?.rel;
        commit('SET_TASK', res.data.task_id);
        commit('SET_TASK_STATE', res.data.state);
        commit('SET_OPERATION', runningOperation);
        return res;
      });
  },

  RUN_OPERATION_ACTION({ state, dispatch }, payload = {}) {
    const { operation = state.operation, taskId = state.taskId, action, body } = payload;
    if (!operation || !taskId || !action) {
      return Promise.reject();
    }

    return this.$api.post(`/api/v2/network/${operation}/${taskId}/${action}/`, body)
      .then(() => dispatch('GET_OPERATION_STATE'));
  },

  FETCH_NETWORK_CONFIGURATION({ commit }, { params, options }) {
    const getBestNode = nodes => nodes.find(({ source_interface: ifs }) => ifs.up && ifs.addresses.length) || nodes[0];
    return this.$api.get('/api/v2/network/migration/config/', params, options)
      .then((res) => {
        commit('SET_ALERTS', res.data.alerts);

        // Backend uses sample response formatter
        // so the response structure may confuse:
        // Here we get an array of nodes with equal target and source interfaces
        // so we should take source interface from the first node to calculate the subnet

        const nodes = res.data.nodes || [];
        // eslint-disable-next-line camelcase
        const netParams = getBestNode(nodes)?.source_interface;
        if (netParams) {
          const cidr = netParams.addresses[0] && ip.cidrSubnet(netParams.addresses[0]);
          if (cidr) {
            commit('SET_NETWORK_CONFIGURATION', {
              networkId: res.data.network_id,
              configuration: {
                cidr: `${cidr.networkAddress}/${cidr.subnetMaskLength}`,
                subnet: cidr.networkAddress,
                mask: cidr.subnetMask,
                gateway: netParams.gateway,
                alerts: netParams.alerts,
                nodes: res.data.nodes,
                up: netParams.up
              }
            });
          }
        }
        return res;
      });
  },

  CLEAR_OPERATION_STATE({ commit }) {
    commit('FLUSH_STATE');
  },

  socket_trafficTypeAssignment({ commit }, data) {
    commit('SET_TASK', STATUSES.success.includes(data.state) ? '' : data.task_id);
    commit('SET_TASK_STATE', data.state);
    commit('SET_TASK_PROGRESS', data.progress);
    commit('SET_OPERATION_DETAILS', data.configuration);
    commit('SET_REASON', data.reason);
    commit('SET_OPERATION', OPERATIONS.TRAFFIC_TYPE_ASSIGNMENT);
  },

  socket_networkMigration({ commit }, data) {
    commit('SET_TASK', STATUSES.success.includes(data.state) ? '' : data.task_id);
    commit('SET_TASK_STATE', data.state);
    commit('SET_TASK_PROGRESS', data.progress);
    commit('SET_OPERATION_DETAILS', data.configuration);
    commit('SET_REASON', data.reason);
    commit('SET_SINGLE_INTERFACE_MIGRATION', data.single_interface_migration);
    commit('SET_OPERATION', OPERATIONS.NETWORK_MIGRATION);
  },
};
